// src/utils/colors.js
export const COLORS = {
    primary: '#6a0dad',
    secondary: '#00a8a9',
    primaryLight: '#8b3fd9',
    secondaryLight: '#00d4d5',
    primaryDark: '#4a0a8d',
    text: '#333',
    textLight: '#666',
    background: '#f8f9fa',
    white: '#ffffff'
  };